<template>
  <v-card class="mx-auto" outlined>
    <v-card-title v-if="!editStatus">{{ value }}</v-card-title>
    <v-card-text v-if="!editStatus">{{ label }}</v-card-text>
    <v-list-item v-if="editStatus">
      <v-list-item-content>
        <v-list-item-title class="headline">
          <v-text-field
            v-model="currentValue"
            v-if="!isTextArea"
          ></v-text-field>
          <v-textarea v-else="" v-model="currentValue"></v-textarea>
        </v-list-item-title>
        <v-list-item-subtitle>{{ label }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-actions>
      <v-btn text v-if="!editStatus" @click="editButtonClick">Edit</v-btn>
      <div v-if="editStatus">
        <v-btn text @click="saveButtonClick">Save</v-btn>
        <v-btn text @click="cancelButtonClick">Cancel</v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'BaseSimpleTextCard',
  props: {
    label: {
      type: String,
      required: true,
      default: 'Label Placeholder'
    },
    value: {
      type: String,
      required: true,
      default: 'Value Placeholder'
    },
    isTextArea: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      editStatus: false,
      mediaItemComponents: [],
      currentValue: ''
    }
  },
  methods: {
    editButtonClick: function(e) {
      this.editStatus = !this.editStatus
    },
    saveButtonClick: function(e) {
      this.editStatus = !this.editStatus
      this.$emit('saveEvent', this.currentValue)
    },
    cancelButtonClick: function(e) {
      this.editStatus = !this.editStatus
    }
  },
  created: function() {
    this.currentValue = this.value
  }
}
</script>

<style scoped></style>
